/* lp-glasgow — built by feral·landers. Edit landers/glasgow/page.js, not this. */
(function(){"use strict";var LP_ROOT="#lp-glasgow",LP_NAME="glasgow";
/* ═══════════════════════════════════════════════════════════════════════════
   feral·landers — base.js
   Wrapped in one IIFE by kit/build.mjs, which also injects LP_ROOT and LP_NAME.
   A lander's own page.js runs after this and can use everything below.
   No framework, no modules — this is a theme asset and it has to run alone.
   ═══════════════════════════════════════════════════════════════════════════ */

var LP = {};
var root = document.querySelector(LP_ROOT);
if (!root) return;                       // the section is not on this page

var $  = function (sel, ctx) { return (ctx || root).querySelector(sel); };
var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var isPhone = function () { return window.matchMedia('(max-width: 989px)').matches; };

LP.root = root; LP.$ = $; LP.$$ = $$; LP.reduced = reduced; LP.isPhone = isPhone;

/* Everything the data bridge hands us came out of Shopify admin, where a product
   title legitimately contains & and quotes. Escape before it touches innerHTML. */
function esc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
LP.esc = esc;

/* ── THE DATA BRIDGE ──────────────────────────────────────────────────────
   The ~30 lines of Liquid in the section shell emit live product data as JSON:
   variant ids, size labels, availability and PRICES ALREADY RENDERED BY THE
   SERVER in the visitor's market currency.
   🚨 Never format money in here. Shopify does not currency-convert a number you
   typed; the server's string is the only one that is definitely true, and a
   client that cannot convert must do nothing rather than show GBP.
   (part: server-honest-money-fx-upgrade)                                     */
LP.data = (function () {
  var el = document.getElementById('lp-' + LP_NAME + '-data');
  if (!el) return { products: {}, settings: {} };
  try { return JSON.parse(el.textContent); } catch (e) { return { products: {}, settings: {} }; }
})();
LP.product = function (key) { return LP.data.products && LP.data.products[key]; };

document.body.classList.add('lp-live');

/* ── PORTAL ───────────────────────────────────────────────────────────────
   🚨 The lander root sets `overflow-x: clip`, and in Safari ANY ancestor with
   overflow clip/hidden, a transform or a filter kills `position: fixed` — the
   element scrolls with the page. Invisible on desktop Chrome. So anything fixed
   is moved out to <body> before it is ever shown.
   (part: fixed-dock-outside-the-clip-ancestor · portal-overlay-to-body)      */
LP.portal = function (el) { if (el && el.parentNode !== document.body) document.body.appendChild(el); return el; };
$$('[data-lp-portal]').forEach(LP.portal);

/* ── THE THEME CHROME IS A MOVING TARGET ──────────────────────────────────
   Two stacked sticky layers (marquee at top:0, header at top:32px) and the group
   COLLAPSES on scroll: 105px at rest, 73px in motion. A hardcoded number is
   wrong half the time.
   🚨 The collapse is a CSS transition, so it finishes AFTER the last scroll
   event — one reading latches a stale value and a full-height band scrolls
   through the gap. Re-measure at ~200ms and ~500ms after scrolling stops.     */
(function chrome() {
  var group = document.querySelector('.shopify-section-group-header-group') ||
              document.querySelector('#shopify-section-header') ||
              document.querySelector('header');
  if (!group) return;
  var write = function () {
    var b = group.getBoundingClientRect().bottom;
    root.style.setProperty('--lp-chrome', Math.max(0, Math.round(b)) + 'px');
  };
  var t1, t2;
  var onScroll = function () {
    write();
    clearTimeout(t1); clearTimeout(t2);
    t1 = setTimeout(write, 200);
    t2 = setTimeout(write, 500);
  };
  write();
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(write);
})();

/* ── REVEALS ──────────────────────────────────────────────────────────────
   Arms only once we know JS is alive, so a script failure leaves a readable
   page rather than a blank one. Nothing in the first viewport is armed: it
   would fade in on load, read as a slow page, and cost LCP on the one element
   that matters most.                                                          */
(function reveals() {
  var items = $$('.lp-rv');
  if (!items.length || !('IntersectionObserver' in window)) return;
  var fold = window.innerHeight;
  var below = items.filter(function (el) { return el.getBoundingClientRect().top > fold * 0.9; });
  if (!below.length) return;
  root.classList.add('is-armed');
  items.forEach(function (el) { if (below.indexOf(el) < 0) el.classList.add('is-in'); });
  if (reduced) { below.forEach(function (el) { el.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.02 });
  below.forEach(function (el) { io.observe(el); });
})();

/* ── THE CART ─────────────────────────────────────────────────────────────
   The proven add-from-anywhere flow, lifted from assets/feral-plp.js.
   🚨 Send it FORM-ENCODED and ask for the drawer sections in the SAME request.
   A JSON body with {items:[…]} genuinely lands the line item and still leaves
   the drawer painting its cached empty state — /cart.js says the item is there
   while the drawer says BAG EMPTY. That is the signature of bypassing the
   section render. (part: cart-add-with-section-rerender)
   The Meta CAPI layer in snippets/feral-events.liquid patches window.fetch and
   fires AddToCart off /cart/add.js by itself — do not emit a second event.    */
var inflight = false;
LP.addToCart = function (items) {
  if (inflight) return Promise.resolve(null);
  inflight = true;
  var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  var fd = new FormData();
  items.forEach(function (it, i) {
    fd.append('items[' + i + '][id]', String(it.id));
    fd.append('items[' + i + '][quantity]', String(it.quantity || 1));
  });
  if (cart && typeof cart.getSectionsToRender === 'function') {
    fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    fd.append('sections_url', window.location.pathname);
    if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
  }
  var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
  return fetch(url, {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
    body: fd
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      // Shopify returns a JSON body with `status` for a sold-out variant even
      // when the HTTP status is inconsistently 200.
      if (data.status) throw new Error(data.description || data.message || 'add failed');
      if (cart) {
        // Remove is-empty or the drawer keeps painting its empty state over
        // correct contents. Do NOT open the drawer by hand — renderContents
        // already opens it, and doing both fights the transition.
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (typeof cart.renderContents === 'function') cart.renderContents(data);
      }
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lp-' + LP_NAME, cartData: data });
      }
      return data;
    })
    .finally(function () { inflight = false; });
};

/* ── THE SIZE SHEET ───────────────────────────────────────────────────────
   One sheet, portalled to <body>, populated per-call. Mobile gets a bottom
   sheet, desktop the same node centred (CSS decides) — a bottom sheet on a
   1440px screen is a modal for no reason, and an inline shake on a phone
   happens off-screen.
   The sold-out row stays FOCUSABLE and readable rather than disabled: a
   disabled control is invisible to a screen reader's tab order and throws away
   the most valuable moment on the page — someone who wants a thing you do not
   have. (part: the-buy-box-is-one-pill-in-three-states)                       */
var sheet, scrim, lastFocus;
function ensureSheet() {
  if (sheet) return;
  scrim = document.createElement('div');
  scrim.className = 'lp-sheet-scrim';
  sheet = document.createElement('div');
  sheet.className = 'lp-sheet';
  sheet.setAttribute('role', 'dialog');
  sheet.setAttribute('aria-modal', 'true');
  sheet.setAttribute('aria-label', 'Choose a size');
  document.body.appendChild(scrim);
  document.body.appendChild(sheet);
  scrim.addEventListener('click', closeSheet);
  addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
}
function closeSheet() {
  if (!sheet) return;
  sheet.classList.remove('is-open');
  scrim.classList.remove('is-open');
  document.body.classList.remove('lp-locked');
  if (lastFocus && lastFocus.focus) lastFocus.focus();
}
LP.closeSheet = closeSheet;

/**
 * LP.pickSize(productKey, onPick) — onPick(variant) when a size is chosen.
 * Returns false and does nothing if the product is not in the data bridge.
 */
LP.pickSize = function (key, onPick) {
  var p = LP.product(key);
  if (!p) return false;
  ensureSheet();
  lastFocus = document.activeElement;
  var rows = p.variants.map(function (v) {
    var cls = 'lp-sheet__row' + (v.available ? '' : ' is-out');
    var right = v.available
      ? (v.low ? '<span class="lp-sheet__low">low stock</span>' : '')
      : '<span class="lp-sheet__out">sold out</span>';
    return '<button type="button" class="' + cls + '" data-vid="' + v.id + '"' +
           (v.available ? '' : ' data-out="1"') + '>' +
           '<span class="lp-sheet__size">' + esc(v.title) + '</span>' + right + '</button>';
  }).join('');
  sheet.innerHTML =
    '<div class="lp-sheet__head">' +
      '<div><div class="lp-sheet__eyebrow">' + esc(p.eyebrow) + '</div>' +
      '<div class="lp-sheet__title">' + esc(p.title) + '</div></div>' +
      '<button type="button" class="lp-sheet__x" aria-label="Close">&#10005;</button>' +
    '</div>' +
    '<div class="lp-sheet__grid">' + rows + '</div>' +
    '<a class="lp-sheet__link" href="' + esc(p.url) + '">Size guide and full detail &#8599;</a>';
  sheet.querySelector('.lp-sheet__x').addEventListener('click', closeSheet);
  Array.prototype.forEach.call(sheet.querySelectorAll('.lp-sheet__row'), function (b) {
    b.addEventListener('click', function () {
      if (b.getAttribute('data-out')) { window.location.href = p.url; return; }
      var v = p.variants.filter(function (x) { return String(x.id) === b.getAttribute('data-vid'); })[0];
      closeSheet();
      onPick(v);
    });
  });
  scrim.classList.add('is-open');
  sheet.classList.add('is-open');
  if (isPhone()) document.body.classList.add('lp-locked');
  // Focus the DIALOG, not the first size. `.focus()` on a row trips the
  // :focus-visible heuristics even from a tap, so the first size lights up with
  // a ring and reads as already chosen — on the one control where "nothing is
  // chosen yet" is the whole point. (part: size-deselected-until-the-url-picks-one)
  sheet.setAttribute('tabindex', '-1');
  sheet.focus();
  return true;
};

/* ── THE DOCK ─────────────────────────────────────────────────────────────
   Raised once the hero is behind you, so it never covers the first CTA.       */
LP.dockOn = function (afterEl) {
  var dock = document.querySelector('.lp-dock');   // portalled to <body>, so query the document
  if (!dock || !afterEl) return;
  if (!('IntersectionObserver' in window)) { dock.classList.add('is-up'); return; }
  new IntersectionObserver(function (e) {
    dock.classList.toggle('is-up', !e[0].isIntersecting);
  }, { threshold: 0 }).observe(afterEl);
};

/* Smooth in-page jumps that respect reduced motion. */
LP.jumpTo = function (el) {
  if (!el) return;
  el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
};
$$('[data-lp-jump]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    var target = $(a.getAttribute('data-lp-jump'));
    if (!target) return;
    e.preventDefault();
    LP.jumpTo(target);
  });
});

window.LP = LP;

/* FERAL x PRTY, Glasgow. Runs after kit/base.js inside the same IIFE: LP, $, $$ are live.
   Three jobs: get the film moving on a phone, take the email into SEND IT as Glasgow-only
   interest, and tell Meta exactly what happened on the page. A script error here costs the
   show, never the sign-up: the form is a plain form until this file takes it over. */

var S = (LP.data && LP.data.settings) || {};
var X = (LP.data && LP.data.extras) || {};
var SCOPE = S.scope || 'launch:feral-prty-glasgow';
var LIVE = X.theme_role === 'main' && !/[?&]preview_theme_id=/.test(location.search);
var ENDPOINT = 'https://mail.feralclo.com/api/subscribe';
var JOINED_KEY = 'feral:prty-glasgow:joined';
var PENDING_KEY = 'feral:prty-glasgow:pending';
var CONSENT = 'Only emails about FERAL x PRTY in Glasgow. No newsletter. Unsubscribe any time.';
var SHARE_BASE = 'https://www.feralclo.com/pages/glasgow?utm_medium=referral&utm_campaign=feral-prty-glasgow';
var SHARE_TEXT = 'FERAL and PRTY have got something coming for Scotland. Get on the list with me';
/* FERAL's own WhatsApp, +44 7424 693600 (2026-10-20). SEND IT's feral-sendit-whatsapp answers it: the film, their
   pass, and a Bring your mates button. WA_LIVE stays false until Meta is sending the number's messages to SEND IT,
   because a message sent before then reaches nobody. */
var WA_NUMBER = '447424693600';
var WA_LIVE = true;
var LAUNCH_API = 'https://mail.feralclo.com/api/launch';
var REF_KEY = 'feral:prty-glasgow:ref';
var CODE_RE = /^GLA-[2-9A-Z]{4,6}$/;
// Whoever's link brought them (?r=GLA-7K4Q). The first link wins; it rides on their sign-up so the mate is counted.
(function () { var r = (location.search.match(/[?&]r=(GLA-[2-9A-Za-z]{4,6})(?:&|$)/) || [])[1]; if (r && !read(REF_KEY)) store(REF_KEY, r.toUpperCase()); })();

var stage = $('.m-stage'), media = $('.m-media'), video = $('.m-video');

/* ── THE BAR: the email box stays in reach all the way down ───────────────
   Once the hero's form has scrolled away it comes down from the top (a bar at the foot sits behind a phone's
   keyboard and under the cookie banner); at the end the page's own form takes over. On the list it turns into
   the way back to the share panel. It stays put while someone is typing in it. */
var bar = document.querySelector('.m-bar'), barSeen = { row: true, share: false, end: false };
function barTick() {
  if (!bar) return;
  var here = hasJoined() ? barSeen.share : barSeen.row;
  var typing = bar.contains(document.activeElement);
  bar.classList.toggle('is-up', typing || (!here && !barSeen.end));
  bar.classList.toggle('is-in', hasJoined());
}
var input = $('#m-email');

/* ── TRACKING ─────────────────────────────────────────────────────────────
   The theme's own tracker (assets/feral-owned-tracking.js, window.__feral) already
   owns consent, the Meta pixel, _fbp/_fbc, the visitor id and the Conversions API
   (events.feralclo.com/api/t). This page rides it rather than building a second one:
   - Lead goes through __feral.trackBoth: ONE event id to the browser pixel AND to the
     server, so Meta de-duplicates it and the server copy carries the hashed email.
   - Every other step is a browser custom event ("Glasgow…") for Events Manager and
     custom conversions, plus a Clarity tag so the replays can be filtered by it.
   Nothing fires before the visitor's advertising permission allows it, and nothing
   leaves a staging theme: there it is logged to the console instead.               */
var sent = {};
function feral() { return window.__feral || null; }
function adAllowed() {
  try { var f = feral(); return !!(f && f.advertisingPermission && f.advertisingPermission().allowed); } catch (e) { return false; }
}
function step(name, data, every) {
  if (!every && sent[name]) return;
  sent[name] = true;
  var ev = 'Glasgow' + name, payload = Object.assign({ page: 'feral-prty-glasgow' }, data || {});
  if (!LIVE) { try { console.info('[glasgow] would send', ev, payload); } catch (e) {} return; }
  try { if (adAllowed() && window.fbq) window.fbq('trackCustom', ev, payload); } catch (e) {}
  try { if (window.clarity) window.clarity('event', ev); } catch (e) {}
}
function lead(email) {
  var f = feral();
  if (!f || !f.trackBoth) { setTimeout(function () { if (feral() && feral().trackBoth) lead(email); }, 1500); return; }
  // The tracker reads the email for the server copy from __feral.customer; a guest has none.
  if (!(f.customer && f.customer.email)) f.customer = Object.assign({}, f.customer || {}, { email: email });
  var data = { content_name: 'Glasgow sign-up', content_category: SCOPE, status: 'joined' };
  if (!LIVE) { try { console.info('[glasgow] Lead → pixel + Conversions API (test mode on staging)', data); } catch (e) {} }
  try { f.trackBoth('Lead', data); } catch (e) {}
  try { if (LIVE && window.clarity) { window.clarity('event', 'GlasgowLead'); window.clarity('set', 'glasgow', 'joined'); } } catch (e) {}
}

step('View', { joined: hasJoined() ? 'yes' : 'no' });

/* ── THE FILM ON A PHONE ──────────────────────────────────────────────────
   The proven ladder (parts: hero-video-autoplay-ladder, video-poster-snaps-never-fades):
   muted/playsInline as properties AND attributes before the source, a try on every ready
   event, the first touch as the user gesture, bfcache and visibility, and a poll that
   stops itself. The poster sits above the video and snaps off only once frames move, so
   Low Power Mode shows a still that looks meant, never Safari's play button. */
(function loop() {
  if (!video || !X.loop_phone) return;
  var calm = LP.reduced || (navigator.connection && navigator.connection.saveData);
  if (calm) return;
  var played = false, tries = 0;
  video.muted = true; video.defaultMuted = true; video.playsInline = true;
  video.setAttribute('muted', ''); video.setAttribute('playsinline', ''); video.setAttribute('webkit-playsinline', '');
  function tryPlay() {
    video.muted = true;
    var p; try { p = video.play(); } catch (e) {}
    if (p && p.catch) p.catch(function () {});
  }
  video.addEventListener('playing', function () {
    if (video.currentTime > 0 || !video.paused) { played = true; media.classList.add('is-playing'); step('LoopPlaying'); }
  });
  ['loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough'].forEach(function (e) { video.addEventListener(e, tryPlay); });
  video.addEventListener('pause', function () { if (!document.hidden) tryPlay(); });
  video.addEventListener('error', function () { try { video.load(); } catch (e) {} });
  var gestures = ['touchstart', 'touchend', 'click', 'keydown'];
  function onGesture() { tryPlay(); if (played) gestures.forEach(function (g) { document.removeEventListener(g, onGesture, true); }); }
  gestures.forEach(function (g) { document.addEventListener(g, onGesture, { passive: true, capture: true }); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) tryPlay(); });
  window.addEventListener('pageshow', tryPlay);
  var poll = setInterval(function () {
    if ((played && !video.paused && video.readyState >= 3) || ++tries > 40) { clearInterval(poll); return; }
    tryPlay();
  }, 1500);
  // One element, its source chosen once: the upright render on a phone, the wide one on a desktop.
  video.src = window.matchMedia('(min-width: 900px)').matches ? X.loop_wide : X.loop_phone;
  tryPlay();
})();

function toShare() { $('.m-share').scrollIntoView({ behavior: LP.reduced ? 'auto' : 'smooth', block: 'center' }); }

/* ── THE FILM: the teaser with its sound, in the stories player ──────────
   One video element (iOS lets sound carry on in the element the tap started). Hold: pause.
   Swipe down or Escape: close. It ends on the list. */
var REEL = [{ key: 'teaser', src: X.st_film, poster: X.stp_film }].filter(function (r) { return r.src; });
var reel = LP.portal($('.m-reel') || document.querySelector('body > .m-reel'));
var rv = reel && reel.querySelector('.m-reel__v');
var ri = 0, rOpener = null, rHold = 0, rHeld = false, rMuted = false, rRaf = 0, rNext = null;
function rq(sel) { return reel.querySelector(sel); }
function reelBars() {
  var bars = rq('.m-reel__bars'); bars.innerHTML = '';
  REEL.forEach(function () { var b = document.createElement('span'); b.className = 'm-reel__bar'; b.appendChild(document.createElement('i')); bars.appendChild(b); });
}
function reelPaint() {
  var bars = reel.querySelectorAll('.m-reel__bar i');
  for (var k = 0; k < bars.length; k++) {
    var p = k < ri ? 1 : k > ri ? 0 : (rv.duration ? Math.min(1, rv.currentTime / rv.duration) : 0);
    bars[k].style.setProperty('--p', p.toFixed(4));
  }
  if (!reel.hidden) rRaf = requestAnimationFrame(reelPaint);
}
function reelGo(n) {
  if (n < 0) n = 0;
  if (n >= REEL.length) { reelEnd(); return; }
  ri = n;
  var r = REEL[ri];
  rv.poster = r.poster || ''; rv.src = r.src; rv.muted = rMuted;
  var p; try { p = rv.play(); } catch (e) {} if (p && p.catch) p.catch(function () { rv.muted = true; rMuted = true; muteUi(); try { rv.play(); } catch (e) {} });
  reel.querySelector('.m-reel__arrow--prev').disabled = ri === 0;
  // fetch the next while this one plays
  var nx = REEL[ri + 1];
  if (nx) { if (!rNext) { rNext = document.createElement('video'); rNext.preload = 'auto'; rNext.muted = true; } rNext.src = nx.src; try { rNext.load(); } catch (e) {} }
  step('FilmView', { film: r.key, n: ri + 1 }, true);
}
function muteUi() { var m = rq('.m-reel__mute'); m.setAttribute('aria-pressed', rMuted ? 'true' : 'false'); m.setAttribute('aria-label', rMuted ? 'Sound on' : 'Sound off'); }
function reelCta() {
  var on = hasJoined();
  rq('.m-reel__cta').textContent = on ? 'Who\u2019s coming with you?' : 'Get on the list';
}
function openFilm() {
  if (!reel || !rv || !REEL.length) return;
  rOpener = document.activeElement;
  reelBars(); reelCta(); muteUi();
  reel.hidden = false; document.body.classList.add('m-locked');
  try { video.pause(); } catch (e) {}
  reelGo(0);
  cancelAnimationFrame(rRaf); rRaf = requestAnimationFrame(reelPaint);
  rq('.m-reel__x').focus({ preventScroll: true });
  step('FilmOpen', null, true);
}
function closeFilm() {
  if (!reel || reel.hidden) return;
  try { rv.pause(); } catch (e) {}
  rv.removeAttribute('src'); try { rv.load(); } catch (e) {}
  reel.hidden = true; document.body.classList.remove('m-locked'); cancelAnimationFrame(rRaf);
  try { video.play().catch(function () {}); } catch (e) {}
  if (rOpener && rOpener.focus) rOpener.focus({ preventScroll: true });
}
function reelEnd() { closeFilm(); toForm(); }
function toForm() {
  if (hasJoined()) { toShare(); return; }
  stage.scrollIntoView({ behavior: LP.reduced ? 'auto' : 'smooth', block: 'end' });
  setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, LP.reduced ? 0 : 450);
}
if (reel && rv) {
  $$('.m-film').forEach(function (b) { b.addEventListener('click', openFilm); });
  rq('.m-reel__x').addEventListener('click', closeFilm);
  rq('.m-reel__mute').addEventListener('click', function () { rMuted = !rMuted; rv.muted = rMuted; muteUi(); });
  rq('.m-reel__cta').addEventListener('click', function () { step('FilmCta', { film: REEL[ri].key }, true); reelEnd(); });
  rq('.m-reel__arrow--prev').addEventListener('click', function () { reelGo(ri - 1); });
  rq('.m-reel__arrow--next').addEventListener('click', function () { reelGo(ri + 1); });
  rv.addEventListener('ended', function () { reelGo(ri + 1); });
  // tap zones: a quick tap moves, a hold pauses until let go
  ['prev', 'next'].forEach(function (side) {
    var z = rq('.m-reel__tap--' + side);
    z.addEventListener('pointerdown', function () { rHeld = false; clearTimeout(rHold); rHold = setTimeout(function () { rHeld = true; rv.pause(); reel.classList.add('is-paused'); }, 220); });
    var up = function () { clearTimeout(rHold); if (rHeld) { rHeld = false; reel.classList.remove('is-paused'); try { rv.play(); } catch (e) {} } };
    z.addEventListener('pointerup', up); z.addEventListener('pointercancel', up); z.addEventListener('pointerleave', up);
    z.addEventListener('click', function (e) { if (rHeld) { e.preventDefault(); return; } reelGo(side === 'next' ? ri + 1 : ri - 1); });
    z.addEventListener('contextmenu', function (e) { e.preventDefault(); });
  });
  // swipe down to close
  var y0 = null;
  rq('.m-reel__frame').addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; }, { passive: true });
  rq('.m-reel__frame').addEventListener('touchend', function (e) { if (y0 !== null && e.changedTouches[0].clientY - y0 > 90) closeFilm(); y0 = null; }, { passive: true });
  reel.addEventListener('click', function (e) { if (e.target === reel) closeFilm(); });
  document.addEventListener('keydown', function (e) {
    if (reel.hidden) return;
    if (e.key === 'Escape') closeFilm();
    else if (e.key === 'ArrowRight') reelGo(ri + 1);
    else if (e.key === 'ArrowLeft') reelGo(ri - 1);
  });
}

/* ── FIRST TIME IN SCOTLAND: scroll pushes into the Academy and the words come up over it ──
   One picture and two numbers on the section, written once a frame while it is on screen. */
(function walk() {
  var sec = $('.m-walk');
  if (!sec || LP.reduced) return;
  sec.classList.add('is-live');
  var raf = 0, seen = false;
  function tick() {
    raf = 0;
    var r = sec.getBoundingClientRect(), span = r.height - innerHeight;
    var p = span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 0;
    var on = p > .35;
    sec.style.setProperty('--wp', p.toFixed(4));
    sec.classList.toggle('is-end', on);
    barSeen.end = on; barTick();
    if (on && !seen) { seen = true; step('FileSeen'); }
  }
  function kick() { if (!raf) raf = requestAnimationFrame(tick); }
  window.addEventListener('scroll', kick, { passive: true });
  window.addEventListener('resize', kick);
  tick();
})();

/* ── TIME TO GET FERAL IN SCOTLAND: the film's line, a word at a time as you scroll, over our own crowds ──
   The clip only runs while the section is on screen; a phone that will not play it keeps the still. */
(function build() {
  var sec = $('.m-build'); if (!sec) return;
  var v = $('.m-build__v'), words = $$('.m-build__w');
  if (LP.reduced) { words.forEach(function (w) { w.classList.add('is-on'); }); return; }
  sec.classList.add('is-live');
  var raf = 0, seen = false, loaded = false;
  function tick() {
    raf = 0;
    var r = sec.getBoundingClientRect(), span = r.height - innerHeight;
    var p = span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 0;
    words.forEach(function (w, k) { w.classList.toggle('is-on', p > .08 + k * .28); });
    if (p > .5 && !seen) { seen = true; step('BuildSeen'); }
  }
  function kick() { if (!raf) raf = requestAnimationFrame(tick); }
  window.addEventListener('scroll', kick, { passive: true });
  window.addEventListener('resize', kick);
  tick();
  if (!v || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (es) {
    var on = es[0].isIntersecting;
    if (on && !loaded) {
      loaded = true; v.muted = true; v.playsInline = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      v.addEventListener('playing', function () { sec.classList.add('is-playing'); });
      v.src = window.matchMedia('(min-width: 900px)').matches ? X.crowd_wide : X.crowd_phone;
    }
    if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
  }, { rootMargin: '30% 0px' }).observe(sec);
})();

/* ── THE END: its own form, and once on the list, back to the share panel ── */
$$('.m-jump-in').forEach(function (b) { b.addEventListener('click', function () { step('JumpToShare'); toShare(); }); });

/* ── THE FORM ─────────────────────────────────────────────────────────────
   SEND IT's scoped-interest door: a `launch:` source is stored as Glasgow interest
   only (no newsletter permission, and the welcome flow skips it), and success is
   believed only when SEND IT says it stored THIS scope. A typo'd domain is offered
   back before it is sent, because a sign-up we cannot reach is not a sign-up. */
var FIXES = { 'gmial.com': 'gmail.com', 'gamil.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gmail.con': 'gmail.com', 'gmail.co': 'gmail.com', 'gnail.com': 'gmail.com', 'gmail.co.uk': 'gmail.com', 'hotmial.com': 'hotmail.com', 'hotmail.con': 'hotmail.com', 'hotmail.co': 'hotmail.co.uk', 'hotmai.co.uk': 'hotmail.co.uk', 'outlok.com': 'outlook.com', 'outlook.con': 'outlook.com', 'yaho.com': 'yahoo.com', 'yahoo.con': 'yahoo.com', 'yahoo.co': 'yahoo.co.uk', 'icloud.con': 'icloud.com', 'iclod.com': 'icloud.com', 'icoud.com': 'icloud.com' };
function clean(v) { return String(v || '').trim().replace(/^mailto:/i, '').replace(/[\s​-‍﻿]/g, '').replace(/[.,;:]+$/, '').toLowerCase(); }
function valid(v) { return v.length <= 254 && /^[^@\s]+@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,18}$/i.test(v); }
function suggest(v) { var p = v.split('@'); return p.length === 2 && FIXES[p[1]] ? p[0] + '@' + FIXES[p[1]] : ''; }
function store(k, v) { try { v === null ? localStorage.removeItem(k) : localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
function read(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
function hasJoined() { var j = read(JOINED_KEY); return !!(j && j.at); }
function hex(n) { return Array.prototype.map.call(crypto.getRandomValues(new Uint8Array(n)), function (x) { return ('0' + x.toString(16)).slice(-2); }).join(''); }

function capture(email) {
  var prev = read(PENDING_KEY);
  var pending = prev && prev.email === email && Date.now() - Date.parse(prev.occurred_at) < 6 * 864e5 ? prev
    : { email: email, capture_id: hex(16), occurred_at: new Date().toISOString() };
  if (!pending.code) pending.code = makeCode();
  store(PENDING_KEY, pending);
  var uid = null; try { uid = feral() && feral().uid ? String(feral().uid) : null; } catch (e) {}
  var body = Object.assign({}, pending, { source: SCOPE, scope: SCOPE, page: location.origin + location.pathname, consent_wording: CONSENT, consent_version: S.consent_version || 'feral-prty-glasgow-v1' });
  if (uid) body.uid = uid;
  var ref = read(REF_KEY); if (ref && ref !== pending.code) body.ref = ref;
  var ctl = window.AbortController ? new AbortController() : null, t = ctl && setTimeout(function () { ctl.abort(); }, 15000);
  return fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true, signal: ctl ? ctl.signal : undefined })
    .then(function (r) { return r.json().catch(function () { return {}; }).then(function (b) { return { r: r, b: b }; }); })
    .then(function (x) {
      if (!x.r.ok || x.b.ok !== true || x.b.stored !== true || x.b.scope !== SCOPE) {
        var e = new Error(x.b && x.b.error || 'not_stored'); e.status = x.r.status; throw e;
      }
      store(PENDING_KEY, null);
      // SEND IT keeps one code a person: a code already taken, or this email's earlier one, comes back here.
      if (CODE_RE.test(String(x.b.code || ''))) pending.code = x.b.code;
      return pending;
    })
    .finally(function () { if (t) clearTimeout(t); });
}

/* Three forms, one sign-up: the hero's, the bar that stays at the top while you scroll, and the one at the end.
   Each keeps its own button and messages; a join from any of them lands on the share panel. */
function wire(form) {
  var field = form.querySelector('input[type="email"]'), btn = form.querySelector('button[type="submit"]'), label = form.querySelector('.m-btn__label');
  var err = form.querySelector('.m-err'), hint = form.querySelector('.m-hint'), fix = form.querySelector('.m-fix');
  var from = form.getAttribute('data-from'), started = false;
  function showErr(msg) { err.textContent = msg; err.hidden = !msg; field.setAttribute('aria-invalid', msg ? 'true' : 'false'); }
  function busy(on) { btn.setAttribute('aria-busy', on ? 'true' : 'false'); label.textContent = on ? 'Getting you on…' : 'Get on the list'; }
  field.addEventListener('focus', function () { if (!started) { started = true; step('FormStart', { from: from }, true); } });
  field.addEventListener('input', function () { if (!err.hidden) showErr(''); hint.hidden = true; });
  fix.addEventListener('click', function () { field.value = fix.getAttribute('data-v'); hint.hidden = true; field.focus(); });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var email = clean(field.value);
    field.value = email;
    if (!valid(email)) { showErr(email ? 'That email doesn’t look right. Check it and try again.' : 'Put your email in first.'); step('SubmitError', { reason: email ? 'invalid' : 'empty', from: from }, true); field.focus(); return; }
    var s = suggest(email);
    if (s && fix.getAttribute('data-v') !== s) {
      fix.setAttribute('data-v', s); fix.textContent = 'Did you mean ' + s + '?'; hint.hidden = false;
      step('TypoOffered', { from: from }, true); return;
    }
    showErr(''); busy(true); step('SubmitAttempt', { from: from }, true);
    capture(email).then(function (p) {
      store(JOINED_KEY, { at: new Date().toISOString(), code: (p && p.code) || makeCode() });
      lead(email);
      busy(false); field.blur();
      joined(true);
    }).catch(function (x) {
      busy(false);
      var limited = x && x.status === 429;
      showErr(limited ? 'Too many tries from here. Give it a minute and try again.' : 'That didn’t go through. Check your signal and try again.');
      step('SubmitError', { reason: limited ? 'rate_limited' : String(x && (x.status || x.message) || 'network').slice(0, 40), from: from }, true);
    });
  });
}

/* ── ON THE LIST ─────────────────────────────────────────────────────────
   Every person on the list gets a code of their own (GLA-7K4Q), kept with their join on this
   device. It rides on every link they send as utm_content, so the tracker can say who brought
   whom, and it is printed on their pass. Nothing on the pass is made up: no number, no count. */
var ABC = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';
function makeCode() { return 'GLA-' + Array.prototype.map.call(crypto.getRandomValues(new Uint8Array(4)), function (x) { return ABC[x % 32]; }).join(''); }
function myCode() {
  var j = read(JOINED_KEY) || {};
  if (!j.code) { j.code = makeCode(); j.at = j.at || new Date().toISOString(); store(JOINED_KEY, j); }
  return j.code;
}
function shareUrl(how) { return SHARE_BASE + '&r=' + myCode() + '&utm_source=' + how + '&utm_content=' + encodeURIComponent(myCode().toLowerCase()); }

function joined(fresh) {
  stage.setAttribute('data-state', 'in');
  document.body.classList.add('m-joined');
  $('.m-open').hidden = true; $('.m-in').hidden = false;
  $('.m-wa').href = 'https://wa.me/?text=' + encodeURIComponent(SHARE_TEXT + ': ' + shareUrl('whatsapp'));
  waJoin(); progress(); barTick();
  if (fresh) {
    // The lights come on: the film's own flash, once (the CSS drops it for reduced motion).
    var fl = $('.m-flash'); if (fl) { fl.classList.remove('is-on'); void fl.offsetWidth; fl.classList.add('is-on'); }
    $('.m-in').classList.add('is-fresh'); $('.m-title__in').classList.add('is-fresh');
    try { if (navigator.vibrate) navigator.vibrate([18, 40, 18]); } catch (e) {}
    // Wherever they joined from, the next thing is who they bring: from far down the page go straight there.
    var far = $('.m-share').getBoundingClientRect().top < -innerHeight;
    if (far) $('.m-share').scrollIntoView({ behavior: 'auto', block: 'center' });
    else setTimeout(function () {
      var r = $('.m-share').getBoundingClientRect();
      if (r.bottom > innerHeight || r.top < 0) toShare();
    }, 700);
  }
  drawPass();
}

/* ── THE PASS: their story card, drawn here from the film's last frame ──
   1080x1920, words kept inside Instagram's safe area (clear of the top 250 and bottom 280). */
var passFile = null, passUrl = '', drawing = null;
function fit(ctx, text, width, max) {
  ctx.font = max + 'px FeralAnton, Anton, Impact, sans-serif';
  var w = ctx.measureText(text).width; return Math.min(max, max * width / w);
}
function drawPass() {
  if (drawing) return drawing;
  drawing = new Promise(function (done) {
    var img = new Image();
    img.decoding = 'async';
    img.onload = function () {
      var fonts = document.fonts && document.fonts.load ? Promise.all([document.fonts.load('100px FeralAnton'), document.fonts.load('700 30px FeralInter')]).catch(function () {}) : Promise.resolve();
      fonts.then(function () {
        try {
          var W = 1080, H = 1920, P = 96, c = document.createElement('canvas'); c.width = W; c.height = H;
          var x = c.getContext('2d');
          x.fillStyle = '#050505'; x.fillRect(0, 0, W, H);
          x.drawImage(img, 0, 0, W, H);
          var g = x.createLinearGradient(0, 1000, 0, 1500); g.addColorStop(0, 'rgba(5,5,5,0)'); g.addColorStop(1, 'rgba(5,5,5,.9)');
          x.fillStyle = g; x.fillRect(0, 1000, W, H - 1000);
          x.fillStyle = '#f5f5f7'; x.textBaseline = 'alphabetic';
          var big = fit(x, 'SCOTLAND', W - 2 * P, 300);
          x.font = big + 'px FeralAnton, Anton, Impact, sans-serif'; x.fillText('SCOTLAND', P, 1330);
          var line = 'I’M ON THE LIST', sub = fit(x, line + '.', W - 2 * P, 300);
          x.font = sub + 'px FeralAnton, Anton, Impact, sans-serif'; x.fillText(line, P, 1330 + sub * 1.02);
          x.fillStyle = '#ff0033'; x.fillText('.', P + x.measureText(line).width, 1330 + sub * 1.02);
          var y = 1330 + sub * 1.02 + 70;
          x.fillStyle = 'rgba(255,0,51,.9)'; x.fillRect(P, y, 64, 6);
          x.fillStyle = '#f5f5f7'; x.font = '700 28px FeralInter, Inter, system-ui, sans-serif';
          if ('letterSpacing' in x) x.letterSpacing = '4px';
          x.fillText('FERALCLO.COM/GLASGOW', P, y + 70);
          x.fillStyle = 'rgba(245,245,247,.6)'; x.textAlign = 'right'; x.fillText(myCode(), W - P, y + 70);
          c.toBlob(function (blob) {
            if (!blob) return done(null);
            try { passFile = new File([blob], 'feral-x-prty-glasgow.png', { type: 'image/png' }); } catch (e) { passFile = blob; }
            passUrl = URL.createObjectURL(blob);
            var el = $('.m-pass__img'); el.src = passUrl; el.hidden = false;
            done(passFile);
          }, 'image/png');
        } catch (e) { done(null); }
      });
    };
    img.onerror = function () { done(null); };
    img.src = X.story_bg;
  });
  return drawing;
}

var toastT = 0;
function toast(msg) {
  var t = $('.m-copied'); t.textContent = msg; t.classList.add('is-on');
  clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
}
function copyLink(how) {
  var url = shareUrl(how);
  var ok = function () { toast('Link copied. Paste it to them.'); $('.m-link').classList.add('is-done'); step('Share', { method: 'copy_link' }, true); };
  if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(ok, function () { window.prompt('Copy this link', url); });
  else window.prompt('Copy this link', url);
}

$('.m-send').addEventListener('click', function () {
  var b = this;
  if (!navigator.share) return copyLink('share');
  navigator.share({ title: 'FERAL x PRTY, Glasgow', text: SHARE_TEXT + ':', url: shareUrl('share') }).then(function () {
    step('Share', { method: 'share_sheet' }, true);
    b.classList.add('is-sent'); $('.m-send__l').textContent = 'Send it to someone else';
  }).catch(function () {});
});
$('.m-link').addEventListener('click', function () { copyLink('link'); });
$('.m-wa').addEventListener('click', function () { this.classList.add('is-done'); step('Share', { method: 'whatsapp' }, true); });

// The story: the share sheet with the picture alone (Instagram drops a picture that comes with
// text), drawn before the tap so Safari still counts the tap as theirs. Instagram's and Facebook's
// own browsers (about half of this page's phones, MEASURED 26 Oct) cannot share a picture at all:
// there the picture opens full screen to press and hold and save, then post. A download on a computer.
var hold = LP.portal($('.m-hold') || document.querySelector('body > .m-hold'));
function canShareFile(f) { try { return !!(f && navigator.share && navigator.canShare && navigator.canShare({ files: [f] })); } catch (e) { return false; } }
function onPhone() { return !!(window.matchMedia && matchMedia('(pointer: coarse)').matches); }
function storyDone(method) { step('Share', { method: method }, true); $('.m-story').classList.add('is-done'); }
// iPhone puts the apps you use most at the front of the share menu, so Instagram is often off to the right:
// say so at the top of the screen, which stays in view above the menu (Harry, 26 Oct, could not find it).
var guide = LP.portal($('.m-guide') || document.querySelector('body > .m-guide'));
function guideOff() { if (guide) guide.classList.remove('is-on'); }
function shareFile(f) {
  if (guide) { guide.hidden = false; void guide.offsetWidth; guide.classList.add('is-on'); }
  navigator.share({ files: [f] }).then(function () { guideOff(); storyDone('story'); }).catch(function (e) {
    guideOff();
    // NotAllowedError: the tap went stale while the picture was drawn. AbortError: they closed the sheet.
    if (e && e.name === 'NotAllowedError') openHold();
  });
}
function openHold() {
  if (!passUrl || !hold) return;
  $('.m-hold__img', hold).src = passUrl;
  hold.hidden = false; document.body.classList.add('m-locked');
  storyDone('story_hold');
}
function closeHold() { if (!hold) return; hold.hidden = true; document.body.classList.remove('m-locked'); }
function download() {
  var a = document.createElement('a'); a.href = passUrl; a.download = 'feral-x-prty-glasgow.png';
  document.body.appendChild(a); a.click(); a.remove();
  toast('Saved. Put it on your story.'); storyDone('story_download');
}
function postStory() {
  if (canShareFile(passFile)) return shareFile(passFile);
  drawPass().then(function (f) {
    if (!passUrl) return;
    if (canShareFile(f)) shareFile(f);
    else if (onPhone()) openHold();
    else download();
  });
}
if (hold) {
  $('.m-hold__x', hold).addEventListener('click', closeHold);
  hold.addEventListener('click', function (e) { if (e.target === hold) closeHold(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !hold.hidden) closeHold(); });
}
$('.m-story').addEventListener('click', postStory);
$('.m-pass').addEventListener('click', postStory);

// A mouse tilts the pass like a card in the hand.
if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !LP.reduced) {
  var pass = $('.m-pass'), card = $('.m-pass__card');
  pass.addEventListener('pointermove', function (e) {
    var r = pass.getBoundingClientRect(), px = (e.clientX - r.left) / r.width - .5, py = (e.clientY - r.top) / r.height - .5;
    pass.classList.add('is-tilt'); card.style.setProperty('--ry', (px * 18).toFixed(2) + 'deg'); card.style.setProperty('--rx', (-py * 14).toFixed(2) + 'deg');
  });
  pass.addEventListener('pointerleave', function () { pass.classList.remove('is-tilt'); card.style.setProperty('--ry', '0deg'); card.style.setProperty('--rx', '0deg'); });
}

/* ── THE SHARE DOOR: the confirmation email's "More ways to share" lands here (?share=1, or ?share=story
   for "Put it on your story"). The email proves they are on the list, but they are usually in another
   browser (Gmail's or Instagram's) from the one they joined in, so this device is told. No Lead and no
   capture: they joined already. The share sheet needs a tap of their own, so the button they want glows. */
/* ── WHATSAPP FIRST, AND THE MATES METER (2026-10-20) ──────────────────────
   On the list: "Get it on WhatsApp first" opens FERAL's chat with their code typed, so their WhatsApp joins their
   email. Their meter asks SEND IT how many people their link has brought (counts only, never a name); three is first
   tickets for all of them. A mate who arrived on a link can join on WhatsApp instead of the form. */
function waLink(text) { return 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(text); }
function waJoin() {
  var a = $('.m-wajoin'); if (!a || !WA_LIVE) return;
  a.href = waLink('I\u2019m in. My code is ' + myCode());
  a.hidden = false;
}
function progress() {
  var code = myCode(); if (!CODE_RE.test(code)) return;
  fetch(LAUNCH_API + '?scope=' + encodeURIComponent(SCOPE) + '&code=' + encodeURIComponent(code), { cache: 'no-store' })
    .then(function (r) { return r.json(); })
    .then(function (b) { if (b && b.ok) drawDeal(b); })
    .catch(function () {});
}
function drawDeal(b) {
  var d = $('.m-deal'); if (!d) return;
  var n = Math.min(3, b.brought | 0);
  $$('.m-meter i').forEach(function (i, k) { i.classList.toggle('is-on', !!b.first_tickets || k < n); });
  if (b.first_tickets) {
    d.classList.add('is-won');
    $('.m-deal__t').textContent = 'You\u2019re all getting first tickets.';
    $('.m-meter__n').textContent = (b.brought | 0) ? (b.brought | 0) + ' mates joined' : 'Your mates brought you in';
  } else $('.m-meter__n').textContent = n + ' of 3 joined';
  if (b.on_whatsapp) { var a = $('.m-wajoin'); if (a) a.hidden = true; }
}
document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && hasJoined()) progress(); });
(function () {
  var a = $('.m-wajoin');
  if (a) a.addEventListener('click', function () { a.classList.add('is-done'); step('WhatsAppJoinTap', { from: 'on_the_list' }, true); });
  var ref = read(REF_KEY), alt = $('.m-wa-alt');
  if (!alt || !WA_LIVE || !ref || hasJoined()) return;
  alt.href = waLink('I\u2019m in. ' + ref + ' sent me');
  alt.hidden = false;
  alt.addEventListener('click', function () { step('WhatsAppJoinTap', { from: 'mate_link' }, true); });
})();

var door = (location.search.match(/[?&]share=(1|story)\b/) || [])[1];
if (door && !hasJoined()) store(JOINED_KEY, { at: new Date().toISOString(), code: makeCode(), via: 'email' });
Array.prototype.forEach.call(document.querySelectorAll('.m-form'), wire);
if (hasJoined()) joined(false);
(function () {
  if (!bar) return;
  var logo = $('.m-logo'), marks = bar.querySelector('.m-bar__marks');
  if (logo && marks) marks.insertBefore(logo.cloneNode(true), marks.firstChild);
  bar.querySelector('.m-bar__share').addEventListener('click', function () { step('BarShare', null, true); toShare(); });
  if (!('IntersectionObserver' in window)) { barSeen.row = false; barTick(); return; }
  new IntersectionObserver(function (e) { barSeen.row = e[e.length - 1].isIntersecting; barTick(); }).observe($('.m-stage .m-row'));
  new IntersectionObserver(function (e) { barSeen.share = e[e.length - 1].isIntersecting; barTick(); }).observe($('.m-share'));
  bar.addEventListener('focusout', function () { setTimeout(barTick, 200); });
})();
if (door) {
  step('ShareDoor', { from: 'email', kind: door });
  var glow = $(door === 'story' ? '.m-story' : '.m-send');
  setTimeout(function () {
    $('.m-share').scrollIntoView({ behavior: LP.reduced ? 'auto' : 'smooth', block: 'center' });
    if (glow) glow.classList.add('is-call');
  }, 500);
  if (glow) glow.addEventListener('click', function () { glow.classList.remove('is-call'); }, { once: true });
}

$('.m-again').addEventListener('click', function () {
  store(JOINED_KEY, null);
  stage.setAttribute('data-state', 'open');
  document.body.classList.remove('m-joined');
  $('.m-open').hidden = false; $('.m-in').hidden = true;
  barTick();
  input.value = ''; input.focus();
});

/* ── A HAND LAMP: on a desktop, a little red light follows the cursor ── */
if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !LP.reduced) {
  var raf = 0, mx = 0, my = 0;
  stage.addEventListener('pointermove', function (e) {
    var r = stage.getBoundingClientRect(); mx = e.clientX - r.left; my = e.clientY - r.top;
    if (!raf) raf = requestAnimationFrame(function () { raf = 0; stage.style.setProperty('--mx', mx + 'px'); stage.style.setProperty('--my', my + 'px'); stage.classList.add('is-torch'); });
  });
  stage.addEventListener('pointerleave', function () { stage.classList.remove('is-torch'); });
}

})();